import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=4ecd3e19&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./tabs.scss?vue&type=style&index=0&id=4ecd3e19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecd3e19",
  null
  
)

export default component.exports